import {createSlice} from '@reduxjs/toolkit';
import {httpGet, httpPost} from '../../../../util/Rest';

const initialData = {
  creditBalanceControlData: {},
  creditBalanceControlStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'CreditBalanceControl',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchCreditBalanceControlData: (state, action) => {
      state.creditBalanceControlData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postCreditBalanceControlData: (state, action) => {
      state.creditBalanceControlStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchCreditBalanceControlData,
  resetMsg,
  postCreditBalanceControlData,
  fetchStart,
  fetchError,
} = slice.actions;

export const fetchCreditBalanceControl = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`maintenance/find/debtorcreditbalancecontrol/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchCreditBalanceControlData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const postCreditBalanceControl = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`maintenance/save/debtorcreditbalancecontrol`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCreditBalanceControlData(data));
          dispatch(fetchCreditBalanceControl(details.clientNumber));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
